import { ChangeEvent, useState } from "react";

// material ui
import { Grid, Typography, Divider } from "@mui/material";

// project import
import Selector from "components/select/selector";
import { useTranslation } from "utils/locales/utilityFunctions";
import RawWoodInputInformationSpecies, {
  RawWoodInputInformationSpeciesHandle,
  RawWoodSpeciesItem,
} from "./rawWoodInputInformationSpecies";
import TextFieldInput from "components/input/textField";
import { FirestoreInventoryItemProps } from "types/auth";
import { RawWoodOptionProps } from "./options";

interface RawWoodInputInformationSpeciesAssortmentProps {
  variant: FirestoreInventoryItemProps["inventoryType"];
  disableInputs: boolean;
  initSpeciesArray?: RawWoodSpeciesItem[];
  speciesOptions: any[];
  speciesRef: React.RefObject<RawWoodInputInformationSpeciesHandle | null>;
  assortmentOptions: RawWoodOptionProps[];
  assortment: string;
  averageLogLength: string;
  averageLogDiameter: string;
  setAssortment: (value: string) => void;
  setAverageLogLength: (event: ChangeEvent<HTMLInputElement>) => void;
  setAverageLogDiameter: (event: ChangeEvent<HTMLInputElement>) => void;
}

const RawWoodInputInformationSpeciesAssortment = ({
  variant,
  disableInputs,
  initSpeciesArray,
  speciesOptions,
  speciesRef,
  assortmentOptions,
  assortment,
  averageLogLength,
  averageLogDiameter,
  setAssortment,
  setAverageLogLength,
  setAverageLogDiameter,
}: RawWoodInputInformationSpeciesAssortmentProps) => {
  // --- Hooks --- //
  const { translate } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5">
          {translate(
            "input-dialog-raw-wood-tab-information-species-and-grading"
          )}
        </Typography>
      </Grid>

      <RawWoodInputInformationSpecies
        initSpeciesArray={initSpeciesArray}
        speciesOptions={speciesOptions}
        disableInputs={disableInputs}
        ref={speciesRef}
      />

      <Grid item xs={12}>
        <Divider sx={{ mt: 1, mb: 1 }} />
      </Grid>

      {variant !== "WoodChipStack" && (
        <Grid item xs={12} sm={12 / 3}>
          <Selector
            title={translate(
              "input-dialog-raw-wood-tab-information-species-and-grading-assortment"
            )}
            value={assortment}
            options={assortmentOptions}
            label={true}
            fullWidth={true}
            error={false}
            changeHandler={(e) => setAssortment(e.target.value)}
            disabled={disableInputs}
          />
        </Grid>
      )}

      {variant !== "WoodChipStack" && (
        <Grid item xs={6} sm={12 / 3}>
          <TextFieldInput
            title={translate(
              "input-dialog-raw-wood-tab-information-species-and-grading-length"
            )}
            value={averageLogLength}
            showLabel={true}
            fullWidth={true}
            disabled={disableInputs}
            inputAdornment={"m"}
            handleChange={setAverageLogLength}
          />
        </Grid>
      )}

      {variant !== "WoodChipStack" && (
        <Grid item xs={6} sm={12 / 3}>
          <TextFieldInput
            title={translate(
              "input-dialog-raw-wood-tab-information-species-and-grading-avg-dia"
            )}
            value={averageLogDiameter}
            showLabel={true}
            fullWidth={true}
            disabled={disableInputs}
            inputAdornment={"cm"}
            handleChange={setAverageLogDiameter}
          />
        </Grid>
      )}
    </>
  );
};

export default RawWoodInputInformationSpeciesAssortment;
